export const SEARCH_USERS_RESULTS = "app/SEARCH_USERS_RESULTS";
export const SEARCH_USERS = "app/SEARCH_USERS";
export const SET_USERS_LOADING = "app/SET_USERS_LOADING";
export const UPDATE_USER_DATA = "app/UPDATE_MEMBER_DATA";
export const CHANGE_PAGE = "app/USERS_CHANGE_PAGE";
export const CHANGE_PER_PAGE = "app/USERS_CHANGE_PER_PAGE";
export const CHANGE_USER_MFA = "app/CHANGE_USER_MFA";
